var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item button",
    on: {
      "click": function($event) {
        _vm.isModalActive = true
      }
    }
  }, [_vm._v("\n            What's this ?\n          ")])])])])]), _vm._v(" "), _c('info-modal', {
    attrs: {
      "active": _vm.isModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isModalActive = $event
      }
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": "static/img/icons/icon-128x128.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "app-logo-name"
  }, [_vm._v("LandmarksVue")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f4302a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroHeader.vue
// module id = tB4R
// module chunks = 1